import styled from "styled-components";

export const ModalReabrirCriativoStyled = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  z-index: 2;

  .div-body {
    width: 90%;
    max-width: 720px;
    padding: 50px;
    background-color: var(--base01);
    margin: 0 auto;
    border-radius: 8px;
    position: relative;
  }

  .close {
    position: absolute;
    top: -15px;
    right: -15px;
    color: var(--base01);
    background-color: #fa5252;
    padding: 12px 13.4px;
    font-size: 28px;
    font-weight: 300;
    border-radius: 30px;
    cursor: pointer;
  }

  .width-90 {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  h2{
    display: flex;
    margin: 0 auto;
    justify-content: center;
    color: var(--principal);
    font-size: 18px;
    font-weight: 600;
  }

  h3{
    margin: 20px 0px;
  }

  textarea{
    min-width: 100%;
    max-width: 100%;
    min-height: 100px;
    max-height: 200px;
  }
  
  .buttons{
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 30px;
    margin-top: 10px;

    button{
      border: none;
      border-radius: 100px;
      width: 120px;
      height: 35px;
      font-weight: 600;
      font-size: 14px;
    }

    .finalizar{
      background-color: var(--amarelo);
      color: var(--principal);
    }

    .cancelar{
      background-color: var(--principal);
      color: var(--base);
    }
  }
  
`;
